module.exports = __webpack_public_path__ + "static/img/1043_big.e98f150.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1043_big.png
// module id = 0T5R
// module chunks = 1